import { combineReducers } from "redux";
import Mainreducer from "./Mainreducer";
import authReducer from "./userReducer";


export default combineReducers({
    Mainreducer,
    auth: authReducer,
})
